import { generateAddressSummary } from "@onsip/common/services/api/resources/addressSummary/generate-address-summary.helper";
import { MatOptAddressGroup } from "../../addressAutocomplete/address-autocomplete.component";

export const NONE_TRANSFER_OPTION = "None";

export const NONE_TRANSFER_CUSTOM_OPTIONS: MatOptAddressGroup = [
  {
    label: "",
    addresses: [
      generateAddressSummary({
        name: "None",
        aor: NONE_TRANSFER_OPTION
      })
    ]
  }
];

export function convertVmTransferAddress(controlValue: string): string {
  return controlValue !== NONE_TRANSFER_OPTION ? controlValue?.split("@")[0] || "" : "";
}
